<template>
  <div>
    <select
      :class="selectClasses"
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
    >
      <option value="" disabled>{{ placeholder }}</option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "SelectField",
  props: {
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Pilih salah satu",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Array,
      required: true,
      validator(value) {
        return value.every((opt) => "value" in opt && "text" in opt);
      },
    },
    formValidate: {
      type: String,
      default: "",
    },
  },
  computed: {
    selectClasses() {
      return [
        "field-select",
        {
          "border-red-600": this.formValidate && !this.modelValue,
        },
      ];
    },
  },
};
</script>